// PURE DATA + loader arrows. No lazy(), no side effects (see ../types.ts contract).
import type { ModuleManifest } from '../types';

export const contactModule: ModuleManifest = {
  id: 'contact',
  routes: [
    { path: '/contact', load: () => import('../../pages/Contact') },
  ],
  menuItems: [{ title: 'Contact', path: '/contact' }],
};
